import React, { useContext, useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import { ReactComponent as AddShoppingSvg } from "../../assets/icons/add-shopping-bag.svg";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { CartContext } from "../../contexts/CartContext";
import AppContext from "../../AppContext";
import { langComponent } from "../../constants";

const assetsUri = import.meta.env.ASSETS_URI;

import ProgramSketchUpImage from "../../assets/icons/programs/sketchUp.png";
import Program3dsMaxImage from "../../assets/icons/programs/3dsMax.png";
import ProgramRevitImage from "../../assets/icons/programs/autodeskRevit.png";
import ProgramCinema4DImage from "../../assets/icons/programs/cinema4d.png";
import ProgramUnrealImage from "../../assets/icons/programs/unreal.png";
import ProgramAutocadImage from "../../assets/icons/programs/autocad.png";
import ProgramArchicadImage from "../../assets/icons/programs/archicad.png";
import ProgramRhinoImage from "../../assets/icons/programs/rhino.png";

import ProgramVRayImage from "../../assets/icons/programs/vray.png";
import ProgramCoronaImage from "../../assets/icons/programs/corona.png";
import ProgramD5RenderImage from "../../assets/icons/programs/d5render.png";
import ProgramEnscapeImage from "../../assets/icons/programs/enscape.jpg";
import ProgramLumionImage from "../../assets/icons/programs/lumion.png";
import { ReactComponent as ViewSVG } from "../../assets/workExchange/icon-eye.svg";

const Card = ({
  _id,
  banner,
  name,
  apps,
  price,
  createdBy,
  company,
  desc,
  program,
  renderer,
  views,
  designType,
  discount,
  creator,
  brief,
  workJournals,
  isRecommended,
  setLoadRecommended,
  isHideInfo = false,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isCreater, setIsCreater] = useState(false);
  const [isBuy, setIsBuy] = useState(false);
  const [isInCart, setIsInCart] = useState(false);
  const [isAddItems, setIsAddItems] = useState(false);
  const [size, setSize] = useState("m");

  const {
    addItem,
    items: shoppingItems,
    isFetchDetail,
    setIsFetchDetail,
  } = useContext(CartContext);
  const { user, isAuth, toggleAuthModal, getLang } = useContext(AppContext);

  const TranslationWorkExchange = getLang(langComponent.workExchange);

  const PROGRAMS = {
    sketchUp: 1,
    "3dsMax": 2,
    revit: 3,
    cinema4D: 4,
    unreal: 5,
    rhino: 6,
    autocad: 7,
    archicad: 8,
  };

  const RENDERERS = {
    vray: 1,
    corona: 2,
    lumion: 3,
    enscape: 4,
    d5render: 5,
  };

  const handleClick = () => {
    navigate(`/work-exchanges/${_id}`);
    window.scrollTo({ top: 0 });
    if (isRecommended == true) {
      setLoadRecommended(true);
    }
  };

  const handleAddToShoppingCartClick = (e) => {
    e.stopPropagation();
    if (!isAuth) {
      toggleAuthModal(true, "signin");
      return;
    } else {
      addItem(_id, 1);
      setIsAddItems(true);

      toast.success(TranslationWorkExchange("Added to cart"));
    }
  };

  const getProgerm = (program) => {
    if (program == PROGRAMS.sketchUp) {
      return <img src={ProgramSketchUpImage} />;
    } else if (program == PROGRAMS["3dsMax"]) {
      return <img src={Program3dsMaxImage} />;
    } else if (program == PROGRAMS.revit) {
      return <img src={ProgramRevitImage} />;
    } else if (program == PROGRAMS.cinema4D) {
      return <img src={ProgramCinema4DImage} />;
    } else if (program == PROGRAMS.unreal) {
      return <img src={ProgramUnrealImage} />;
    } else if (program == PROGRAMS.rhino) {
      return <img src={ProgramRhinoImage} />;
    } else if (program == PROGRAMS.autocad) {
      return <img src={ProgramAutocadImage} />;
    } else if (program == PROGRAMS.archicad) {
      return <img src={ProgramArchicadImage} />;
    }
  };

  const getRenderers = (renderer) => {
    if (renderer == RENDERERS.vray) {
      return <img src={ProgramVRayImage} />;
    } else if (renderer == RENDERERS.corona) {
      return <img src={ProgramCoronaImage} />;
    } else if (renderer == RENDERERS.lumion) {
      return <img src={ProgramLumionImage} />;
    } else if (renderer == RENDERERS.enscape) {
      return <img src={ProgramEnscapeImage} />;
    } else if (renderer == RENDERERS.d5render) {
      return <img src={ProgramD5RenderImage} />;
    }
  };

  const getView = () => {
    if (!views) return 0;
    if (views < 1000) return views;
    return `${(views / 1000).toFixed(1)}k`;
  };

  useEffect(() => {
    setIsFetchDetail(false);
    if (user?.company) {
      if (company == user.company) {
        setIsCreater(true);
      }
    } else if (user?._id) {
      if (createdBy == user._id) {
        setIsCreater(true);
      } else {
        setIsCreater(false);
      }
    } else {
      setIsCreater(false);
    }

    if (workJournals) {
      const workJournalItem = workJournals.some((journal) => {
        const workJournalItem = journal.details.find(
          (item) => item.work === _id
        );
        return workJournalItem;
      });
      setIsBuy(workJournalItem);
    }
  }, [user?.id, isFetchDetail, workJournals]);

  useEffect(() => {
    // * check disabled button add item
    if (shoppingItems) {
      let itemInCart = shoppingItems.find((item) => item.work == _id);

      if (itemInCart) {
        setIsInCart(true);
      } else {
        setIsInCart(false);
      }
    }
  }, [shoppingItems, isAddItems, isFetchDetail, id]);

  const ref = useCallback((node) => {
    if (node !== null) {
      const resizeObserver = new ResizeObserver((entries) => {
        const _width = entries[0].contentRect.width;

        if (_width <= 270) {
          setSize("xs");
          return;
        }

        if (_width <= 350) {
          setSize("s");
          return;
        }

        setSize("m");
      });
      resizeObserver.observe(node);
    }
  }, []);

  const _classNames = ["work-exchange-card", `work-exchange-card--${size}`];

  return (
    <div className={_classNames.join(" ")} ref={ref} onClick={handleClick}>
      {!isHideInfo && (
        <div className="work-exchange-card-wrp">
          <div className="work-exchange-card__creator">
            <img
              className="work-exchange-card__creator--avatar"
              src={`${assetsUri}/${creator?.avatar}`}
              onError={({ target }) => {
                target.src = creator?.avatar;
              }}
            />
            <div>{creator?.name}</div>
          </div>
        </div>
      )}
      {discount > 0 && (
        <div className="work-exchange-card__badge">
          {TranslationWorkExchange("SALE")}
        </div>
      )}
      <img
        className="work-exchange-card__image"
        src={`${assetsUri}/${banner}`}
        onError={({ target }) => {
          target.src = banner;
        }}
      />
      {!isCreater && (
        <button
          className={`work-exchange-card__add-cart ${
            isInCart ? "work-exchange-card__add-cart--disabled" : ""
          }  ${isBuy == true ? "work-exchange-card__add-cart--hide" : ""}`}
          onClick={handleAddToShoppingCartClick}
        >
          <AddShoppingSvg width={24} height={24} />
        </button>
      )}
      {isHideInfo !== true && (
        <div className="work-exchange-card-footer">
          <div className="work-exchange-card-footer-content">
            <div className="work-exchange-card-footer-content-wrp">
              <div className="work-exchange-card-footer-content__separator" />
              <div className="work-exchange-card-footer-content-info">
                <div className="work-exchange-card-footer-content-info-apps"></div>
                <div className="work-exchange-card-footer-content-info__views">
                  <ViewSVG /> {getView() ?? 0}
                </div>
                <div className="work-exchange-card-footer-content-info__apps">
                  {TranslationWorkExchange("Create by")} :{" "}
                  {getProgerm(program ?? 1)}
                  {getRenderers(renderer ?? 1)}
                </div>
                <div className="work-exchange-card-footer-content-info__name">
                  {name}
                </div>
                <div className="work-exchange-card-footer-content-info__desc">
                  {brief}
                </div>
              </div>
            </div>
            <div className="work-exchange-card-footer-content-price-wrp">
              {discount > 0 && (
                <span className="work-exchange-card-footer-content__discount">
                  {price.toLocaleString() ?? ""}
                </span>
              )}
              <div
                className={`${
                  discount > 0
                    ? "work-exchange-card-footer-content__price--have-discount"
                    : "work-exchange-card-footer-content__price"
                }`}
              >
                {discount > 0
                  ? (price - discount).toLocaleString()
                  : price == 0
                  ? TranslationWorkExchange("Free")
                  : price?.toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Card.propTypes = {
  _id: PropTypes.string.isRequired,
  banner: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  apps: PropTypes.arrayOf(PropTypes.string),
  isHideInfo: PropTypes.bool,
};

Card.defaultProps = {
  isRecommended: false,
  setLoadRecommended: () => {},
  isHideInfo: false,
};

export default Card;
